import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  LOCALE_ID,
} from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { routes, thaleaProviders } from "./app.routes";
import { createProvider, EnvironmentConfig } from "@keus-template/environment";
import { environment } from "./environments/environment";
import { HttpClientModule } from "@angular/common/http";
import { ApiModule } from "./api/api.module";

/** configuration for the Thalea application */
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    createProvider(EnvironmentConfig, { useValue: environment }),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    importProvidersFrom([
      HttpClientModule,
      ApiModule.forRoot({ rootUrl: environment.apiUrl }),
    ]),
    ...thaleaProviders,
  ],
};
